




























































































































import { Component, Vue } from "vue-property-decorator";
import ventasCabeceraModule from "@/store/modules/ventas_cabecera-module";
import clientsModule from "@/store/modules/client-module";
import { ventas_cabecera } from "@/shared/dtos/ventas_cabecera";
import { RouterNames } from "@/router/routernames";
import { PdfCorporateService } from "@/shared/services/pdf-corporate.service";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";

@Component
export default class VentasCabeceraLista extends Vue {
  loading = false;
  busqueda = "";

  headers = [
    { text: "#", value: "id", width: 60 },
    { text: "Tipo", value: "tipo_documento", width: 110 },
    { text: "Cliente", value: "client_id", width: 220 },
    { text: "Fecha", value: "datecreated", width: 100 },
    { text: "Base Imponible", value: "base_imponible", width: 120 },
    { text: "Beneficio Neto", value: "beneficio_neto", width: 120 },
    { text: "Total", value: "total", width: 100 },
    { text: "Estado", value: "estado", width: 110 },
    { text: "", value: "acciones", sortable: false, width: 100 },
  ];

  get ventasList() {
    return ventasCabeceraModule.ventasList;
  }

  get ventasFiltradas() {
    const q = this.busqueda.trim().toLowerCase();
    if (!q) return this.ventasList;
    return this.ventasList.filter((v: any) => {
      const tipo = (v.tipo_documento || "").toLowerCase();
      const estado = (v.estado || "").toLowerCase();
      const id = String(v.id || "");
      const total = String(v.total || "");
      const cliente = this.getCliente(v.client_id);
      const nombre = cliente ? (cliente.name || "").toLowerCase() : "";
      const email = cliente ? (cliente.email || "").toLowerCase() : "";
      return id.includes(q) || tipo.includes(q) || estado.includes(q) || nombre.includes(q) || email.includes(q) || total.includes(q);
    });
  }

  getCliente(clientId: number) {
    if (!clientId) return null;
    return clientsModule.clientses.find((c) => c.id === clientId) || null;
  }

  async created() {
    this.loading = true;
    await Promise.all([
      ventasCabeceraModule.getVentas(),
      clientsModule.getclientses(),
    ]);
    this.loading = false;
  }

  nuevoDocumento() {
    (this as any).$router.push({
      name: RouterNames.ventas_cabecera_formulario,
      params: { id: "nuevo" },
    });
  }

  verDocumento(item: ventas_cabecera) {
    (this as any).$router.push({
      name: RouterNames.ventas_cabecera_formulario,
      params: { id: String(item.id) },
    });
  }

  async imprimirDocumento(item: ventas_cabecera) {
    try {
      await ventasCabeceraModule.getLineasByCabecera(item.id);
      const lineas = ventasCabeceraModule.lineas;
      const totalAmazon = Number(item.total_amazon) || 0;
      const totalVenta = Number(item.base_imponible) || 0;
      const margenMedio = totalAmazon > 0 ? (totalVenta / totalAmazon) * 100 : 0;

      const columns = [
        { header: "Artículo" },
        { header: "Cant.",       width: 14, align: "center" as "center" },
        { header: "P. Amazon",   width: 28, align: "right"  as "right"  },
        { header: "Precio Venta",width: 28, align: "right"  as "right"  },
        { header: "Dto. %",      width: 20, align: "right"  as "right"  },
        { header: "Total línea", width: 28, align: "right"  as "right"  },
      ];

      const rows: any[] = lineas.map((l) => [
        l.descripcion,
        String(l.cantidad || 1),
        Number(l.precio_amazon).toFixed(2) + " €",
        Number(l.precio_unitario).toFixed(2) + " €",
        (l.descuento || 0) + " %",
        Number(l.total_linea).toFixed(2) + " €",
      ]);
      rows.push(["SUBTOTAL (Base Imponible)", "", totalAmazon.toFixed(2) + " €", totalVenta.toFixed(2) + " €", margenMedio.toFixed(1) + " %", totalVenta.toFixed(2) + " €"]);

      const cliente = this.getCliente(item.client_id);
      const tipo = item.tipo_documento || "documento";
      const tipoLabel = tipo.charAt(0).toUpperCase() + tipo.slice(1);
      const result = await PdfCorporateService.createDoc({
        title: tipoLabel + " #" + item.id,
        clientInfo: cliente || undefined,
        note: (item as any).notas || undefined,
      });

      const finalY = PdfCorporateService.addTable(result.doc, columns, rows, result.contentY, { totalsRowIndex: rows.length - 1 });

      const doc = result.doc;
      const pageW = doc.internal.pageSize.getWidth();
      let y = finalY + 8;

      const iva = Number(item.iva) || 0;
      const recargo = Number(item.recargo_equivalencia) || 0;
      const importeIva = totalVenta * (iva / 100);
      const importeRecargo = totalVenta * (recargo / 100);
      const totalConImpuestos = totalVenta + importeIva + importeRecargo;
      const envio = Number(item.precio_envio) || 0;
      const totalFinal = Number(item.total) || totalConImpuestos + envio;

      if (iva > 0 || recargo > 0) {
        const lineasImp = [
          "Base imponible: " + totalVenta.toFixed(2) + " €",
          ...(iva > 0 ? ["IVA (" + iva + "%): + " + importeIva.toFixed(2) + " €"] : []),
          ...(recargo > 0 ? ["Rec. Equiv. (" + recargo + "%): + " + importeRecargo.toFixed(2) + " €"] : []),
          "---------------------------------",
          "Total artículos: " + totalConImpuestos.toFixed(2) + " €",
        ];
        const boxH = 10 + lineasImp.length * 5.5;
        doc.setFillColor(245, 245, 245);
        doc.roundedRect(8, y, pageW - 16, boxH, 2, 2, "F");
        doc.setTextColor(80, 80, 80); doc.setFontSize(8); doc.setFont("helvetica", "bold");
        doc.text("Desglose de impuestos", 12, y + 6);
        doc.setFont("helvetica", "normal");
        lineasImp.forEach((linea, i) => {
          if (linea.startsWith("Total ")) { doc.setFont("helvetica", "bold"); doc.setTextColor(40, 40, 40); }
          else if (linea.startsWith("----")) { doc.setTextColor(180, 180, 180); }
          else { doc.setFont("helvetica", "normal"); doc.setTextColor(80, 80, 80); }
          doc.text(linea, 12, y + 10.5 + i * 5.5);
        });
        y += boxH + 4;
      }

      doc.setFillColor(230, 246, 240);
      doc.roundedRect(8, y, pageW - 16, 26, 2, 2, "F");
      doc.setTextColor(0, 133, 74); doc.setFontSize(10); doc.setFont("helvetica", "bold");
      doc.text("Rentabilidad y Ahorro Estimado", 12, y + 7);
      doc.setTextColor(60, 60, 60); doc.setFontSize(9); doc.setFont("helvetica", "normal");
      const rendimiento = totalAmazon - totalVenta;
      doc.text("Valor en tienda (Amazon): " + totalAmazon.toFixed(2) + " €. Con Outlet pagas: " + totalVenta.toFixed(2) + " €.\n¡Rendimiento estimado para reventa: " + rendimiento.toFixed(2) + " €!", 12, y + 14);
      y += 30;

      doc.setFillColor(0, 133, 74);
      doc.roundedRect(8, y, pageW - 16, 16, 2, 2, "F");
      doc.setTextColor(255, 255, 255); doc.setFontSize(11); doc.setFont("helvetica", "bold");
      let impExtra = "";
      if (iva > 0) impExtra += "IVA " + iva + "% ";
      if (recargo > 0) { if (impExtra) impExtra += "+ "; impExtra += "R.Eq. " + recargo + "% "; }
      if (envio <= 0) { if (impExtra) impExtra += "+ "; impExtra += "envío gratis "; }
      else if (envio > 0) { if (impExtra) impExtra += "+ "; impExtra += "envío " + envio.toFixed(2) + "€ "; }
      const labelTotal = impExtra ? "TOTAL A PAGAR (" + impExtra.trim() + " incluido)" : "TOTAL A PAGAR";
      doc.text(labelTotal, 12, y + 10);
      doc.setFontSize(12);
      doc.text(totalFinal.toFixed(2) + " €", pageW - 12, y + 10, { align: "right" });

      PdfCorporateService.save(doc, tipo + "_" + item.id);
    } catch (e) {
      alert("Error al generar PDF: " + ((e as any).message || e));
    }
  }

  async eliminar(item: ventas_cabecera) {
    if (!confirm("Eliminar documento #" + item.id + "?")) return;
    await ventasCabeceraModule.eliminarVenta(item.id);
    await ventasCabeceraModule.getVentas();
  }

  formatDate(d: any) {
    if (!d) return "—";
    const dt = new Date(d);
    if (isNaN(dt.getTime()) || dt.getFullYear() < 2000) return "—";
    return dt.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "2-digit" });
  }

  labelEstado(estado: string) {
    const efectivoVisible = !ocultarcamposModule.Ocultar_tarjeta_efectivo;
    const map: Record<string, string> = {
      borrador:         "Borrador",
      enviado:          "Enviado",
      confirmado:       "Confirmado",
      vendida_efectivo: efectivoVisible ? "Pagado (efectivo)" : "Pagado",
      vendida_tarjeta:  efectivoVisible ? "Pagado (tarjeta)"  : "Pagado",
      cancelado:        "Cancelado",
    };
    return map[estado] || estado;
  }
}
